import {
  addNavMenuItem,
  registerHistoryEntryComponent,
} from "@vendure/admin-ui/core";
import { HistoryEntryComponent } from "./history-entry.component";

export default [
  addNavMenuItem(
    {
      id: "sendcloud",
      label: "SendCloud",
      routerLink: ["/extensions/sendcloud"],
      icon: "cloud",
      requiresPermission: "SetSendCloudConfig",
    },
    "settings",
  ),
  registerHistoryEntryComponent({
    type: "SENDCLOUD_NOTIFICATION",
    component: HistoryEntryComponent,
  }),
];
